/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import { t } from 'i18next';


const Schedule = () => {
    return(
        <div className="sect-01-box-01-schedule" style={{textAlign:"center"}}>
            <div className="sect-tit" style={{textAlign:"left"}}>{t("schedule_title1")} {t("schedule_title2")}</div>
            <div className="sect-03-tbl" style={{display:"inline-block", textAlign:"left"}}>
                <p>{t("schedule_date1")}</p>
                <table>
                    <colgroup>
                        {/* <col width="38%"/> */}
                        <col width="25%"/>
                        <col width="25%"/>
                        <col width="15%"/>
                        <col width="15%"/>
                    </colgroup>
                    <tbody>
                    {/* <tr>
                        <th>{t("schedule_date1")}</th>
                    </tr> */}
                    <tr class="purple borderUpBoldPurple">
                        {/* <th rowSpan="8"></th> */}
                        <td>{t("schedule_col1")}</td>
                        <td>{t("schedule_col2")}</td>
                        <td>{t("schedule_col3")}</td>
                        <td>{t("schedule_col4")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_exh_title")}</td>
                        <td>{t("schedule_exh_cont")}</td>
                        <td>{t("schedule_time_1000_1800")}</td>
                        <td>{t("schedule_place_A")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_exp_title")}</td>
                        <td>{t("schedule_exp_cont")}</td>
                        <td>{t("schedule_time_1000_1800")}</td>
                        <td>{t("schedule_place_A_exp")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_glosym1_title")}</td>
                        <td>{t(("schedule_glosym1_cont1"))}<br/>{t("schedule_glosym1_cont2")}</td>
                        <td>{t("schedule_time_1000_1140")}</td>
                        <td>{t("schedule_place_f1_meet")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_prize_title")}</td>
                        <td>{t("schedule_prize_cont1")}<br/>{t("schedule_prize_cont2")}</td>
                        <td>13:00~13:30</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_lec_title")}</td>
                        <td>{t("schedule_lec_cont1")}<br/>{t("schedule_lec_cont2")}</td>
                        <td>13:30~14:10</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_cere_title")}</td>
                        <td>{t("schedule_cere_cont1")}<br/>{t("schedule_cere_cont2")}<br/>{t("schedule_cere_cont3")}</td>
                        <td>{t("schedule_time_1530_1630")}</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    <tr>
                    <td>{t("schedule_glosym2_title")}</td>
                        <td>{t(("schedule_glosym2_cont1"))}<br/>{t("schedule_glosym2_cont2")}</td>
                        <td>{t("schedule_time_1630_1755")}</td>
                        <td>{t("schedule_place_f1_meet")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_gr_title1")}<br/>{t("schedule_gr_title2")}</td>
                        <td>{t("schedule_gr_cont1")}<br/>{t("schedule_gr_cont2")}</td>
                        <td>{t("schedule_time_1700_1800")}</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    </tbody>
                </table>
                <p>{t("schedule_date2")}</p>
                <table>
                    <colgroup>
                        {/* <col width="38%"/> */}
                        <col width="25%"/>
                        <col width="25%"/>
                        <col width="15%"/>
                        <col width="15%"/>
                    </colgroup>
                    <tbody>  
                    <tr class="purple borderUpBoldPurple">
                        {/* <th rowSpan="9">{t("schedule_date2")}</th> */}
                        <td>{t("schedule_col1")}</td>
                        <td>{t("schedule_col2")}</td>
                        <td>{t("schedule_col3")}</td>
                        <td >{t("schedule_col4")}</td>
                    </tr>
                    <tr>
                    <td>{t("schedule_glosym3_title")}</td>
                        <td>{t(("schedule_glosym3_cont1"))}<br/>{t("schedule_glosym3_cont2")}</td>
                        <td>{t("schedule_time_1000_1215")}</td>
                        <td>{t("schedule_place_f1_meet")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_exh_title")}</td>
                        <td>{t("schedule_exh_cont")}</td>
                        <td>{t("schedule_time_1000_1800")}</td>
                        <td>{t("schedule_place_A")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_exp_title")}</td>
                        <td>{t("schedule_exp_cont")}</td>
                        <td>{t("schedule_time_1000_1800")}</td>
                        <td>{t("schedule_place_A_exp")}</td>
                    </tr>
                    {/* <tr>
                        <td>{t("schedule_main_title")}</td>
                        <td>{t("schedule_main_cont1")}<br/>{t("schedule_main_cont2")}</td>
                        <td>{t("schedule_time_1000_1500")}</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr> */}
                    <tr>
                        <td>{t("schedule_ir_title")}</td>
                        <td>{t("schedule_ir_cont1")}<br/>{t("schedule_ir_cont2")}</td>
                        <td>{t("schedule_time_1000_1800")}</td>
                        <td>{t("schedule_place_A_bus")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_concert_title")}</td>
                        <td>{t("schedule_concert_cont1")}<br/>{t("schedule_concert_cont2")}</td>
                        <td>12:30~13:00</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_prize_title")}</td>
                        <td>{t("schedule_prize_cont1")}<br/>{t("schedule_prize_cont2")}</td>
                        <td>13:00~13:30</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_glosym4_title")}</td>
                        <td>{t(("schedule_glosym4_cont1"))}<br/>{t("schedule_glosym4_cont2")}</td>
                        <td>{t("schedule_time_1330_1515")}</td>
                        <td>{t("schedule_place_f1_meet")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_lec_title")}</td>
                        <td>{t("schedule_lec_cont1")}<br/>{t("schedule_lec_cont2")}</td>
                        <td>{t("schedule_time_1500_1620")}</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_quiz_title")}</td>
                        <td>{t("schedule_quiz_cont1")}<br/>{t("schedule_quiz_cont2")}</td>
                        <td>16:20~17:00</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_gr_title1")}<br/>{t("schedule_gr_title2")}</td>
                        <td>{t("schedule_gr_cont1")}<br/>{t("schedule_gr_cont2")}</td>
                        <td>{t("schedule_time_1700_1800")}</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    </tbody>
                </table>
                <p>{t("schedule_date3")}</p>
                <table>
                    <colgroup>
                        {/* <col width="38%"/> */}
                        <col width="25%"/>
                        <col width="25%"/>
                        <col width="15%"/>
                        <col width="15%"/>
                    </colgroup>
                    <tbody>
                    <tr class="purple borderUpBoldPurple">
                        {/* <th rowSpan="8">{t("schedule_date3")}</th> */}
                        <td>{t("schedule_col1")}</td>
                        <td>{t("schedule_col2")}</td>
                        <td>{t("schedule_col3")}</td>
                        <td >{t("schedule_col4")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_exh_title")}</td>
                        <td>{t("schedule_exh_cont")}</td>
                        <td>{t("schedule_time_1000_1700")}</td>
                        <td>{t("schedule_place_A")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_exp_title")}</td>
                        <td>{t("schedule_exp_cont")}</td>
                        <td>{t("schedule_time_1000_1700")}</td>
                        <td>{t("schedule_place_A_exp")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_glosym5_title")}</td>
                        <td>{t("schedule_glosym5_cont1")}<br/>{t("schedule_glosym5_cont2")}</td>
                        <td>{t("schedule_time_1030_1430")}</td>
                        <td>{t("schedule_place_f1_meet")}</td>
                    </tr>
                    {/* <tr>
                        <td>{t("schedule_main_title")}</td>
                        <td>{t("schedule_main_cont1")}<br/>{t("schedule_main_cont2")}</td>
                        <td>{t("schedule_time_1000_1500")}</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr> */}
                    <tr>
                        <td>{t("schedule_job_title")}</td>
                        <td>{t("schedule_job_cont1")}<br/>{t("schedule_job_cont2")}</td>
                        <td>{t("schedule_time_1000_1700")}</td>
                        <td>{t("schedule_place_A_bus")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_nobel_title")}</td>
                        <td>{t("schedule_nobel_cont1")}<br/>{t("schedule_nobel_cont2")}</td>
                        <td>{t("schedule_time_1100_1200")}</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_concert_title")}</td>
                        <td>{t("schedule_concert_cont1")}<br/>{t("schedule_concert_cont2")}</td>
                        <td>12:30~13:00</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_prize_title")}</td>
                        <td>{t("schedule_prize_cont1")}<br/>{t("schedule_prize_cont2")}</td>
                        <td>13:00~13:30</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_quiz_title")}</td>
                        <td>{t("schedule_quiz_cont1")}<br/>{t("schedule_quiz_cont2")}</td>
                        <td>14:00~14:30</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_lec_title")}</td>
                        <td>{t("schedule_lec_cont1")}<br/>{t("schedule_lec_cont2")}</td>
                        <td>{t("schedule_time_1500_1540")}</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    <tr>
                        <td>{t("schedule_gr_title1")}<br/>{t("schedule_gr_title2")}</td>
                        <td>{t("schedule_gr_cont1")}<br/>{t("schedule_gr_cont2")}</td>
                        <td>{t("schedule_time_1600_1700")}</td>
                        <td>{t("schedule_place_A_main")}</td>
                    </tr>
                    </tbody>
                </table>
                {/* <script>
                    document.getElementById('id1').style.backgroundColor='#003F87';
                </script> */}
            </div>
            <div id="menu-05"></div>
        </div>
    )
}

export default Schedule;